<template>
    <div v-if="route.name == 'Store' || route.name == 'Modal' || route.name == 'ModalT'" id="container-shopping-cart-svg" class="flex justify-center">
        <RouterLink to="/tienda/carrito-de-compras" id="option-cart-shopping" class="w-auto flex justify-center h-3/5 my-auto items-center px-special hover:cursor-pointer">
            <span class="w-6 h-full">
                <font-awesome-icon icon="bag-shopping" class="w-full h-full dark:text-primary-dark-text" />
            </span>
            <div v-if="storeS.getShoppingCart() != null" id="mark" class="w-3 h-3 bg-red-error-text rounded-full relative top-1/3 right-mark-b-store-desktop max-md:right-mark-store-mobile max-md:bottom-mark-store-mobile">
            </div>
        </RouterLink>
    </div>
</template>

<style scoped></style>

<script setup>
import { RouterLink } from 'vue-router';
import { shoppingCart } from '@/stores/shoppingCart';
import { generalStore } from '@/stores';

const store = generalStore();
const storeS = shoppingCart();

const route = store.route;
</script>